import URLS from '@/server/urls';
import { POST } from '@/server/http';

export default async ({
    password = '',
}, options = { showError: true }) => {
    const [ content, error, status ] = await POST(URLS.user.verifyPassword, {
        password,
    }, options);
    if (error) return { error, status };
    return content || {};
};

